import { render, staticRenderFns } from "./SwitchPalletForm.vue?vue&type=template&id=d877e668&"
import script from "./SwitchPalletForm.vue?vue&type=script&lang=js&"
export * from "./SwitchPalletForm.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPalletForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports